// extracted by mini-css-extract-plugin
export default {"main":"OTP_main__3qyiV","user":"OTP_user__iQFjb","forms":"OTP_forms__equOw","recieve":"OTP_recieve__RL5i9","submit":"OTP_submit__A4c3p"};